import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../i18n';
import CommentList from './CommentList';
import { Root } from './styles';
import useCommentsScrollManagerVM from './vm';

const CommentsScrollManager = () => {
  const { t } = useTranslation([i18nNS.COMMENTS, i18nNS.GLOSSARY]);

  const { commentListRef } = useCommentsScrollManagerVM();

  return (
    <Root ref={commentListRef} aria-label={t('comments', { ns: i18nNS.GLOSSARY })} role="list">
      <CommentList />
    </Root>
  );
};

export default CommentsScrollManager;
